//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Dropzone from './Dropzone';

export default {
  props: {
    title: String,
    subtitle: String,
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: 'uploadfile-component',
    },
    numMaxArquivos: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
    acceptedFileTypes: {
      type: String,
    },
    maxFileSizeInMB: {
      type: Number,
      default: 50,
    },
    maxNumberOfFiles: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Dropzone,
  },
  methods: {
    fileAdded(...params) {
      this.$emit('UPLOADFILE_FILE_ADDED', ...params);
    },
    fileRemoved(...params) {
      this.$emit('UPLOADFILE_FILE_REMOVED', ...params);
    },
    uploadSuccess(...params) {
      this.$emit('UPLOADFILE_SUCCESS', ...params);
    },
    uploadError(...params) {
      this.$emit('UPLOADFILE_ERROR', ...params);
    },
    uploadSending(...params) {
      this.$emit('UPLOADFILE_SENDING', ...params);
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/upload/UploadFile.vue?vue&type=script&lang=js&